const loading = (state) => {
  return state.loading
}

const dados = (state) => {
  return state.dados
}

export { loading, dados }
